/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateObjectionPositionReductionV1Dto } from './CreateObjectionPositionReductionV1Dto';
export type CreateObjectionPositionV1Dto = {
  /**
   * Comment specific to this line item within the objection
   */
  comment?: string;
  status?: CreateObjectionPositionV1Dto.status;
  /**
   * UUID of the OperatingCostInvoiceLineItem
   */
  lineItemId: string;
  /**
   * The green reduction contribution
   */
  reductionGreen?: CreateObjectionPositionReductionV1Dto;
  /**
   * The yellow reduction contribution
   */
  reductionYellow?: CreateObjectionPositionReductionV1Dto;
  /**
   * The red reduction contribution
   */
  reductionRed?: CreateObjectionPositionReductionV1Dto;
};
export namespace CreateObjectionPositionV1Dto {
  export enum status {
    UNCLEAR = 'Unclear',
    IN_CLARIFICATION = 'InClarification',
    CLARIFIED = 'Clarified',
  }
}
